import GoldenRockBetBarComponent from "goldenrock/components/betbar/golden-rock-bet-bar-component";
import QuickfireExitFreespins from "quickfire/states/quickfire-exit-freespins";
import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import Gameplay from "slotworks/model/gameplay/gameplay";
import { Services } from "slotworks/services/services";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import Contract from "slotworks/utils/contracts/contract";

export default class GoldenRockExitFreespins extends QuickfireExitFreespins {

    public complete() {

        const lastGame: Gameplay = GameState.getCurrentGame();
        const lastRoundWin: number = lastGame.getTotalWin();
        (Components.betBar as GoldenRockBetBarComponent).setLastWinnings(lastRoundWin);

        super.complete();
    }

    protected resetToTriggeringSpin() {
        const gameplay = GameState.getCurrentGame();

        SmartUIFlags.set(SmartUIFlag.FREE_SPINS, false);
        SmartUIFlags.set(SmartUIFlag.PROMPT, false);

        Services.transaction.setBalance(GameState.getCurrentGame().balance);
        Services.transaction.setWinnings(gameplay.getTotalWin()).execute();
        Components.matrix.clearStuckSymbols();

        return Contract.empty();
    }
}
